import { sqliteTable, text, integer } from "drizzle-orm/sqlite-core";
import { vehicleModels } from "./vehicle-models";

// ============================================================================
// vehicle_sub_models — รุ่นย่อย
// ============================================================================
export const vehicleSubModels = sqliteTable("fleet_vehicle_sub_models", {
  id: text("id").primaryKey(), // ULID
  modelId: text("model_id").notNull().references(() => vehicleModels.id),
  name: text("name").notNull(),
  engineSize: text("engine_size"),
  isActive: integer("is_active").notNull().default(1),
  sortOrder: integer("sort_order").notNull().default(0),
  createdAt: text("created_at").notNull(),
  createdBy: text("created_by"),
  updatedAt: text("updated_at").notNull(),
  updatedBy: text("updated_by"),
  deletedAt: text("deleted_at"),
  deletedBy: text("deleted_by"),
});

export type VehicleSubModel = typeof vehicleSubModels.$inferSelect;
export type NewVehicleSubModel = typeof vehicleSubModels.$inferInsert;
